import {
    GET_APPLECONFIG_LOADING,
    GET_APPLECONFIG_SUCCESS,
    GET_APPLECONFIG_FAILED,
  } from "../types";
  
  const initialState = {
    loading: false,
    error: null,
    merchantsConfig: null,
    status:null
  };
  
  export const findAppleConfigReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; error: any, status:any }
  ) => {

    switch (action.type) {
      case GET_APPLECONFIG_LOADING:
        return {
          ...state,
          loading: action.loading,
          error: null,
        };
      case GET_APPLECONFIG_SUCCESS:
        return {
          ...state,
          loading: false,
          merchantsConfig:action.payload,
          error: null,
          status:action.status
        };
      case GET_APPLECONFIG_FAILED:
        return {
          ...state,
          loading: false,
          error: action.error,
          status:action.status,
        };
      
      default:
        return state;
    }
  };
  